import { isAxiosError } from 'axios';

export function getReasonForError(err: unknown): string {
  const httpStatus = isAxiosError(err) ? err.response?.status : undefined;
  return httpStatus ? String(httpStatus) : 'network_error';
}
